module.exports = __webpack_public_path__ + "static/img/paquetexpress.55074b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paquetexpress.svg
// module id = BH/q
// module chunks = 1